import styled from 'styled-components';
import { COLORS,SIZE } from '@app/src/ui';
import { createGlobalStyle } from 'styled-components'

interface Props {
  isActive?: boolean;
  color?: string;
}

export const Wrapper = styled.div`
  width: 60px;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  z-index:1;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  display: none;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: flex;
  }
`;

export const Circle = styled.a`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  margin: 16px auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &.active {
    background: ${(props:Props) => props.color};
    &:before {
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background: ${(props:Props) => props.color};
      position: absolute;
    }
  }
  ${(props: props) => props.isActive ? `
    background: ${props.color};
    &:before {
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background: ${props.color};
      position: absolute;
    }
  ` : `
    background: ${COLORS.GRAY_TEXT};
    &:before {
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background: #fff;
      position: absolute;
    }
  `}
`;


export const Navigation = createGlobalStyle`
  #fp-nav ul li:hover a.active span,
  #fp-nav ul li a.active span,
  .fp-slidesNav ul li:hover a.active span,
  .fp-slidesNav ul li a.active span {
    background-color: black;
  }
`
